var map = {
	"./account.banqup.json": "./src/configs/account.banqup.json",
	"./bank.json": "./src/configs/bank.json",
	"./banqup.json": "./src/configs/banqup.json",
	"./dbc.json": "./src/configs/dbc.json",
	"./employee.nb.json": "./src/configs/employee.nb.json",
	"./energy_shr.json": "./src/configs/energy_shr.json",
	"./epassport.nb.json": "./src/configs/epassport.nb.json",
	"./fmdm.json": "./src/configs/fmdm.json",
	"./identity.banqup.json": "./src/configs/identity.banqup.json",
	"./issuer.bd.json": "./src/configs/issuer.bd.json",
	"./knb.json": "./src/configs/knb.json",
	"./kvk.json": "./src/configs/kvk.json",
	"./legal-entity.banqup.json": "./src/configs/legal-entity.banqup.json",
	"./local-dev.json": "./src/configs/local-dev.json",
	"./loyalty.nb.json": "./src/configs/loyalty.nb.json",
	"./nglr.json": "./src/configs/nglr.json",
	"./notary.json": "./src/configs/notary.json",
	"./omzetbelasting.bd.json": "./src/configs/omzetbelasting.bd.json",
	"./order.nb.json": "./src/configs/order.nb.json",
	"./rp.funke.json": "./src/configs/rp.funke.json",
	"./rp.konkuk-university.json": "./src/configs/rp.konkuk-university.json",
	"./rp.nb.json": "./src/configs/rp.nb.json",
	"./rp.vismayuki.json": "./src/configs/rp.vismayuki.json",
	"./sphereon.json": "./src/configs/sphereon.json",
	"./triall.json": "./src/configs/triall.json",
	"./woonplaatsverklaring.bd.json": "./src/configs/woonplaatsverklaring.bd.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/configs sync recursive ^\\.\\/.*\\.json$";